import { Card, CardContent, Typography } from "@mui/material";

type DataCardProps = {
	title: string;
	value: string | number;
	rag?: boolean;
};

const successStyle = {
	borderColor: "#198025",
	borderWidth: "3px",
	borderStyle: "solid",
	borderRadius: "10px",
};
const failStyle = {
	borderColor: "#D92121",
	borderWidth: "3px",
	borderStyle: "solid",
	borderRadius: "10px",
};

export const DataCard = ({ title, value, rag }: DataCardProps) => (
	<Card
		sx={{
			margin: "0.25em",
			textAlign: "center",
			...(rag === true && {
				...successStyle,
			}),
			...(rag === false && {
				...failStyle,
			}),
		}}
	>
		<CardContent>
			<Typography variant="h5">{title}</Typography>
			<Typography variant="body1">{value}</Typography>
		</CardContent>
	</Card>
);
